import { createContext, useState } from "react"
import API from "services/api"

export const LogPgaContext = createContext({})

const LogPgaProvider = (props) => {
	const [logpgas, setLogpgas] = useState([])
	const [openHistory, setOpenHistory] = useState(false)

	const onOpenHistory = () => {
		setOpenHistory(!openHistory)
	}

	const getLogPgas = (params) => {
		return API.getLogPgas(params)
			.then((res) => {
				const { data } = res
				setLogpgas(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getLogPgabyParent = (id, params) => {
		return API.getLogPgabyParent(id, params)
			.then((res) => {
				const { data } = res
				setLogpgas(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const postLogPga = (data) => {
		return API.postLogPga(data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const putLogPga = (id, data) => {
		return API.putLogPga(id, data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const deleteLogPga = (id) => {
		return API.deleteLogPga(id)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	return (
		<LogPgaContext.Provider
			value={{
				logpgas,

				getLogPgas,
				getLogPgabyParent,
				postLogPga,
				putLogPga,
				deleteLogPga,

				openHistory,
				onOpenHistory
			}}
			{...props}
		/>
	)
}

export default LogPgaProvider
